import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'pbc-newsletter',
  templateUrl: './newsletter.component.html'
})
export class NewsletterComponent implements OnInit {
  newsletterForm: FormGroup;

  constructor() {
    this.newsletterForm = new FormGroup({
      'email' : new FormControl('', [Validators.required, Validators.email]),
      'agreement' : new FormControl(false, [Validators.requiredTrue])
    });
  }

  ngOnInit() {
  }

}
